<template>
  <div class="choice">
    <div class="choice-image">
      <div class="my-upload">
        <!-- <div style="word-break: break-all; white-space: pre-wrap;">{{pictureModal}}</div> -->
        <div class="my-upload-list" v-for="(item, index) in uploadList1" :key="'upload1' + index">
          <template v-if="item.status === 'finished'">
            <img :src="item.url" style="width: 80px;height: 80px;" />
            <div class="my-upload-list-cover">
              <Icon
                type="ios-eye-outline"
                @click.native="handleView1(item.url)"
                style="position: relative;top: -10px;"
              ></Icon>
              <Icon
                type="ios-trash-outline"
                @click.native.stop.prevent="handleRemove1(item)"
                style="position: relative;top: -10px;"
              ></Icon>
            </div>
          </template>
          <template v-else>
            <Spin v-if="item.showProgress" style="width: 80px;height: 80px;">
              <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
            </Spin>
          </template>
        </div>
        <Upload
          ref="upload1"
          :show-upload-list="false"
          :default-file-list="defaultList1"
          :on-success="handleSuccess1"
          :format="['jpg','jpeg','png']"
          :max-size="2048"
          :headers="formHeaders"
          :on-format-error="handleFormatError"
          :on-exceeded-size="handleMaxSize"
          :before-upload="handleBeforeUpload1"
          type="drag"
          :action="uploadUrl"
          style="display: inline-block;"
          v-show="uploadList1 && uploadList1.length < limitNum1"
        >
          <div style="width:80px;height:80px;padding-top: 9px;color:rgb(133, 133, 133)">
            <div style="font-size:25px">
              +
              <p style="font-size:14px">Upload</p>
            </div>
          </div>
          <!-- 蒙版 -->
          <div class="my-upload-cover" v-if="showHome" @click.stop="selectType"></div>
        </Upload>
      </div>
    </div>
    <div class="choice-form">
      <div class="choice-form-item">
        <div class="choice-form-item__title">Picture title</div>
        <div class="choice-form-item__control">
          <Input placeholder="Picture title" style="font-size: 12px;" v-model="picItem.title" />
        </div>
      </div>
      <div class="choice-form-item" style="align-items: flex-start;" v-if="showHome">
        <div class="choice-form-item__title">Hyperlink</div>
        <div class="choice-form-item__control">
          <Dropdown trigger="click" @on-click="selectLink">
            <a href="javascript:void(0)">
              Select
              <Icon type="ios-arrow-down"></Icon>
            </a>
            <DropdownMenu slot="list">
              <!-- 0:自定义,1:公司，2:产品分组，3:产品，4:品牌,5:动态 -->
              <DropdownItem name="0">Custom</DropdownItem>
              <DropdownItem name="1">Company website</DropdownItem>
              <!-- <Dropdown placement="right-start">
                <DropdownItem name="2">
                  产品分组
                  <Icon type="ios-arrow-forward"></Icon>
                </DropdownItem>
                <DropdownMenu slot="list">
                  <DropdownItem
                    style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"
                    v-for="(item,index) of proGroupList"
                    :key="'proGroup' + index"
                    @click.native="selectProGroup(item)"
                  >{{item.name}}</DropdownItem>
                </DropdownMenu>
              </Dropdown>-->
              <Dropdown placement="right-start">
                <DropdownItem name="3">
                  Products
                  <Icon type="ios-arrow-forward"></Icon>
                </DropdownItem>
                <DropdownMenu slot="list">
                  <DropdownItem
                    style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"
                    v-for="(item,index) of proList"
                    :key="'pro' + index"
                    @click.native="selectPro(item)"
                  >{{item.name}}</DropdownItem>
                </DropdownMenu>
              </Dropdown>
              <Dropdown placement="right-start">
                <DropdownItem name="4">
                  Brands
                  <Icon type="ios-arrow-forward"></Icon>
                </DropdownItem>
                <DropdownMenu slot="list">
                  <DropdownItem
                    style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"
                    v-for="(item,index) of brandList"
                    :key="'brand' + index"
                    @click.native="selectBrand(item)"
                  >{{item.name}}</DropdownItem>
                </DropdownMenu>
              </Dropdown>
              <DropdownItem name="5">News</DropdownItem>
              <!-- <DropdownItem
                v-for="(item, index) in linkArr"
                :key="index"
                @click.native="addLink(item)"
              >{{item.label}}</DropdownItem>-->
            </DropdownMenu>
          </Dropdown>
          <template v-if="tag">
            <Tag style="width:130px;" closable @on-close="tagClose">{{tag}}</Tag>
          </template>
          <Input v-show="picItem.link.type === '0'" v-model="picItem.link.value" disabled />
        </div>
      </div>
    </div>

    <!-- 选择文件上传方式 -->
    <imgUpload
      @upload:local="uploadLocal"
      @upload:material="uploadMaterial"
      :maxCount="1"
      v-model="uploadChooseShowed"
    />

    <iModal title="图片查看" cancel-text v-model="visible1" :z-index="1100">
      <div style="text-align: center;">
        <img :src="imgName1" v-if="visible1" style="max-width: 100%" />
      </div>
    </iModal>

    <iModal v-model="linkModal" title="自定义链接" @on-cancel="cancelLink()" :z-index="1100">
      <Form ref="formValidate" :model="formValidate" :rules="ruleInline" :label-width="100">
        <FormItem label="链接地址：" prop="link">
          <Input v-model="formValidate.link" placeholder="请输入链接地址" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="linkModal=false">取消</Button>
        <Button type="primary" :loading="modal_loading" @click="setLink">确定</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import imgUpload from "@components/En/imgUpload/imgUpload.vue";

export default {
  name: "add-picture-item",
  props: {
    picItem: {
      type: Object, 
      default: function() {
        return {
          url: "",
          title: "",
          link: {
            type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 动态）
            value: ""
          }
        };
      }
    }
  },
  model: {
    prop: "picItem",
    event: "sendPicItem"
  },
  watch: {
    picItem(val, oldVal) {
      this.init();
    }
  },
  data() {
    const that = this;
    const urlReg = (rule, value, callback) => {
      if (value !== false) {
        if (!that.formValidate.link) {
          callback("外链地址不能为空");
        }
        if (/(https):\/\/([\w.]+\/?)\S*/.test(that.formValidate.link)) {
          callback();
        } else {
          callback("请输入正确的外链地址");
        }
      } else {
        callback();
      }
    };
    return {
      modal_loading: false,
      linkModal: false,

      formValidate: {
        link: ""
      },
      ruleInline: {
        link: [{ validator: urlReg, trigger: "blur" }]
      },

      imgName1: "",
      visible1: false,
      uploadList1: [],
      defaultList1: [],
      limitNum1: 1, // 图文显示的限制图片个数
      uploadChooseShowed: false, // 控制文件上传方式的显示和隐藏
      tag: null, // 标签数组
      linkArr: [
        {
          label: "Custom",
          value: 0
        },
        {
          label: "Company website",
          value: 1
        },
        {
          label: "产品分组",
          value: 2
        },
        {
          label: "Products",
          value: 3
        },
        {
          label: "Brands",
          value: 4
        },
        {
          label: "News",
          value: 5
        }
      ],
      proList: null,
      brandList: null,
      proGroupList: null,
      albumOption: null, // 上传到素材库的信息
    };
  },
  components: {
    imgUpload
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany"
    }),
    type() {
      return this.info.type;
    },
    showHome() {
      let bool = true;
      if (this.$route.path.indexOf("/host/index") !== -1) {
        bool = false;
      }
      if (this.$route.path.indexOf("/host/project") !== -1) {
        bool = false;
      }
      return bool;
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getProduct: "productModule/getProduct",
      getBrand: "companyModule/getBrand",
      getProductGroup: "productModule/getProductGroup",
      addMaterial: "materialModule/addMaterial"
    }),
    async init() {
      // 初始数据
      let defaultList = [];
      if (this.picItem.url) {
        defaultList.push({
          name: 1,
          url: this.picItem.url,
          status: "finished",
          percentage: 100
        });
      }
      this.uploadList1 = defaultList;
      if (this.showHome) {
        if (this.picItem.link && this.picItem.link.type) {
          if (this.picItem.link.type === "0") {
            this.tag = "Custom";
            if (this.picItem.link.type === "0" && this.picItem.link.value) {
              this.formValidate.link = this.picItem.link.value;
            } else {
              this.picItem.link.type = "-1";
              this.tag = "";
              this.formValidate.link = "";
            }
          }
          if (this.picItem.link.type === "1") {
            this.tag = "Company website";
          }
          if (this.picItem.link.type === "2") {
            this.tag = "产品分组";
            if (this.picItem.link.type === "2" && this.picItem.link.value) {
              this.tag = `产品分组 | ${this.picItem.link.value}`;
            }
          }
          if (this.picItem.link.type === "3") {
            this.tag = "Products";
            if (this.picItem.link.type === "3" && this.picItem.link.value) {
              this.tag = `Products | ${this.picItem.link.value}`;
            }
          }
          if (this.picItem.link.type === "4") {
            this.tag = "Brands";
            if (this.picItem.link.type === "4" && this.picItem.link.value) {
              this.tag = `Brands | ${this.picItem.link.value}`;
            }
          }
          if (this.picItem.link.type === "5") {
            this.tag = "News";
          }
        }
        // 产品列表
        let proList = await this.getProduct({ CompId: this.company.id });
        let proList2 = await this.getProduct({
          CompId: this.company.id,
          pageSize: proList.totalCount
        });
        this.proList = proList.items;
        // 品牌列表
        let brandList = await this.getBrand({ CompId: this.company.id });
        let brandList2 = await this.getBrand({
          CompId: this.company.id,
          pageSize: brandList.totalCount
        });
        this.brandList = brandList2.items;
        // 产品分组列表
        let proGroupList = await this.getProductGroup({
          CompId: this.company.id
        });
        let proGroupList2 = await this.getProductGroup({
          CompId: this.company.id,
          pageSize: proGroupList.totalCount
        });
        this.proGroupList = proGroupList2.items;
      }
    },
    selectProGroup(item) {
      this.tag = `产品分组 | ${item.name}`;
      this.picItem.link.type = "2";
      this.picItem.link.value = item.id;
    },
    selectPro(item) {
      this.tag = `Products | ${item.name}`;
      this.picItem.link.type = "3";
      this.picItem.link.value = item.id;
    },
    selectBrand(item) {
      this.tag = `Brands | ${item.name}`;
      this.picItem.link.type = "4";
      this.picItem.link.value = item.id;
    },
    async setLink() {
      let form = this.formValidate;
      let valid = await this.validForm("formValidate");
      if (!valid) return;
      this.picItem.link.value = this.formValidate.link;
      this.linkModal = false;
    },
    // 验证表单
    validForm(name) {
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancelLink() {
      this.linkModal = false;
      this.picItem.link.type = "";
      this.picItem.link.value = "";
      this.formValidate.link = "";
    },
    tagClose(e) {
      this.tag = null;
      this.picItem.link.type = "";
      this.picItem.link.value = "";
      this.formValidate.link = "";
    },
    selectLink(value) {
      if (value === "0") {
        this.tag = "Custom";
        this.linkModal = true;
        this.picItem.link.type = "0";
      }
      if (value === "1") {
        this.tag = "Company website";
        this.picItem.link.value = "";
        this.picItem.link.type = "1";
      }
      if (value === "5") {
        this.tag = "News";
        this.picItem.link.value = "";
        this.picItem.link.type = "5";
      }
    },
    addComponent() {
      this.visible = false;
    },
    add(item, index) {
      // top 表示在上面添加  bottom表示下面添加
      let idx = this.index;
      if (index === "bottom") {
        idx = this.index + 1;
      }
      this.$emit("add", item, idx);
      this.visible = false;
      this.visible2 = false;
      this.visible3 = false;
      
      
    },
    close() {
      this.$emit("close");
    },

    // 选择图片上传方式
    selectType() {
      this.uploadChooseShowed = true;
    },
    // 文件格式错误
    handleFormatError(file) {
      this.$Message.warning(`Incorrect file format, Upload image in jpg/png format`);
    },
    // 文件过大
    handleMaxSize(file) {
      this.$Message.warning(`File size exceeds configured limit, Upload image size less than 2M`);
    },
    // 上传数量
    handleBeforeUpload1() {
      const limitNum1 = 1;
      const check1 = this.uploadList1.length < limitNum1;
      if (!check1) {
        this.$Message.warning(`Upload ${limitNum1} image only`);
      }
      return check1;
    },
    // 上传成功
    handleSuccess1(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList1 = this.$refs.upload1.fileList;
        this.picItem.url = res.list[0];
        if(this.showHome) {
          this.albumOption.Path = res.list[0];
          this.sendImg();
        }
      }
      this.$emit("changModal", this.picItem);
    },
    sendImg() {
      this.addMaterial(this.albumOption)
        .then(c => { 
        })
        .catch(e => {
          this.$Message.error("添加图片到素材库失败，请重新尝试");
        });
    },
    handleRemove1(file) {
      const copyData = JSON.parse(JSON.stringify(this.picItem));
      copyData.url = '';
      this.$refs.upload1.fileList = [];
      this.$emit("changModal", copyData);
    },
    // 查看上传图片
    handleView1(name) {
      this.imgName1 = name;
      this.visible1 = true;
    },

    // 拦截上传方法
    uploadLocal(album) {
      this.albumOption = album;
      this.$refs.upload1.handleClick();
    },
    // 接收素材库上传的文件
    uploadMaterial(e) {
      for (let item of e) {
        if (this.uploadList1.length >= 1) {
          this.$Message.warning(`Upload one image only`);
          this.uploadChooseShowed = false;
          return;
        } else {
          this.uploadList1.push({
            status: "finished",
            url: item
          });
          this.picItem.url = item;
          this.uploadChooseShowed = false;
        }
      }
      this.$emit("changModal", this.picItem);
    }
  }
};
</script>

<style scoped lang="scss">
.choice {
  min-height: 104px;
  padding: 10px;
  display: flex;
  border: 1px dashed #bfbfbf;
  margin-bottom: 10px;
  &-image {
    width: 80px;
    height: 80px;
  }
  &-form {
    width: calc(100% - 80px);
    // flex-wrap: wrap;
    padding-left: 10px;
    &-item {
      font-size: 12px;
      color: #333;
      display: flex;
      min-height: 32px;
      align-items: center;
      margin-bottom: 10px;
      flex-wrap: wrap;
      &__title {
        width: 62px;
      }
      &__control {
        width: calc(100% - 62px);
        // flex: 1;
        input {
          font-size: 12px !important;
        }
      }
    }
  }
}
.my-upload-list {
  width: 80px;
  height: 80px;
  margin: 0;
  padding: 0;
}
</style>
<style lang="scss">
.choice {
  .ivu-select-dropdown {
    width: 140px;
  }
  .ivu-input {
    font-size: 12px;
  }
}
.my-upload-cover {
  position: absolute;
  opacity: 0;
  width: 80px;
  height: 80px;
  left: 0;
  top: 0;
}
</style>
